import { SxProps, Theme } from '@mui/material';
import { semantic } from '@diligentcorp/atlas-design-tokens/lens';
import { atlasCore, atlasSemantic } from 'src/theme/atlas/tokens';

const textMd = semantic.font.text.md;

export const loading: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  padding: 4,
};

export const heading: SxProps<Theme> = {
  marginBottom: atlasCore.spacing[3],
  fontFamily: semantic.font.title.h3Lg.fontFamily.value,
  fontSize: semantic.font.title.h3Lg.fontSize.value,
  lineHeight: semantic.font.title.h3Lg.lineHeight.value,
  letterSpacing: semantic.font.title.h3Lg.letterSpacing.value,
  fontWeight: semantic.font.title.h3Lg.fontWeight.value,
};

export const tableContainer: SxProps<Theme> = {
  border: `1px solid ${atlasSemantic.color.ui.divider.default}`,
  borderRadius: atlasSemantic.radius.sm,
  overflow: 'hidden',
};

export const pagination: SxProps<Theme> = {
  '& .MuiTablePagination-input .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${atlasSemantic.color.type.muted}`,
    borderRadius: atlasSemantic.radius.sm,
  },
  '& .MuiTablePagination-input.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline':
    {
      border: `1px solid ${atlasSemantic.color.type.muted}`,
    },
  '& .MuiTablePagination-input.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
    {
      border: `1px solid ${atlasSemantic.color.type.muted}`,
    },
  '& .MuiTablePagination-input.MuiOutlinedInput-root.Mui-focused': {
    boxShadow: 'none',
  },
  '& .MuiTablePagination-select .MuiTablePagination-select.MuiSelect-select': {
    fontWeight: 'normal',
  },
};

export const table: SxProps<Theme> = {
  '& .MuiTableCell-head:first-of-type': { borderTopLeftRadius: 0 },
  '& .MuiTableCell-head:last-of-type': { borderTopRightRadius: 0 },
  '& .MuiTableCell-body': {
    fontSize: textMd.fontSize.value,
    lineHeight: textMd.lineHeight.value,
    letterSpacing: textMd.letterSpacing.value,
  },
};
